import ProgixPayment from "../../../components/units/Progix/Payment/ProgixPayment";

export default function ProgixPaymentPage() {
  return <ProgixPayment />;
}
